export const ASSETS = {
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/3su52hhv_WG%20Logo%20Use%20On%20Black.webp",
  team: "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/2aax6sjq_DSC_2116.webp",
  victoria: "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/9eh5oqx8_Victoria.jpg",
  angela: "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/tsoutpx7_Angela.jpg",
  jacob: "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/kc9eecv8_DSC_1911.webp",
  heroHouse: "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/uma3pan8_1_dsc00843.webp",
};

export const AGENTS = [
  {
    id: "angela",
    name: "Angela Watson",
    role: "Founder · Lead Broker",
    photo: ASSETS.angela,
    tagline: "Twenty years of quiet excellence in Central Valley real estate.",
    bio: "Rooted right here in the Central Valley, I bring over ten years of hands-on experience and a heart for service to every client I work with. As team lead of the Watson Group, my goal is simple: to make your real estate experience personal, transparent, and tailored to your unique goals. Whether you're searching for your dream home or taking the next big step for your family, I am here to advocate for you every step of the way. I measure my success by the strength of the relationships I build and the positive impact we make in our local neighborhoods.",
    contact: "angelawatsonhomes@gmail.com",
    phone: "(209) 620-7575",
    instagram: "@angelawatsonhomes",
    dre: "02010115",
  },
  {
    id: "victoria",
    name: "Victoria Orozco",
    role: "Senior Agent",
    photo: ASSETS.victoria,
    tagline: "A sharp negotiator with a designer's eye.",
    bio: "As a Central Valley native, I'm passionate about serving the community that raised me. Real estate gives me the opportunity to help people achieve one of their biggest goals while doing work that I truly enjoy. I'm committed to providing exceptional service, clear communication, and a strong work ethic with every client I meet. My goal is to become one of the most trusted and successful realtors in the Central Valley by consistently putting people first.",
    contact: "vorozco9719@gmail.com",
    phone: "(209) 534-4374",
    instagram: "@vorozco61",
    dre: "02199195",
  },
  {
    id: "jacob",
    name: "Jacob Flora",
    role: "Buyer's Specialist",
    photo: ASSETS.jacob,
    tagline: "Modern process. Old-school discipline.",
    bio: "Born and raised in the Central Valley, I know this community well, and I want to do everything I can to help the members who are a part of it. My goal is to help you find not just a house, but the right home for your life. As a local agent, I'm committed to serving the community I grew up in with honesty, dedication, and genuine care. Whether you're buying your first home or your forever home, I'm here to guide you every step of the way.",
    contact: "jacobflora.realtor@gmail.com",
    phone: "(209) 380-2306",
    instagram: "@jacobflora.realtor",
    dre: "02443861",
  },
];
